import { number2fileSize } from 'core/utils';

export default {
  methods: {
    $fileSize(...args) {
      return number2fileSize(...args);
    }
  }
};
